import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextArea from '@narvar/nth-text-area';
import { updatePickupInstructions } from '../../actions/pickupAddon';

const TextAreaContainer = styled.div`
  margin-top: 1.2rem;
  position: relative;
  label {
    font-weight: 400;
  }
`;

const mapStateToProps = ({ language, pickupAddon: { form: { instructions } = {} } }) => ({
  language,
  instructions,
});

const InstructionsInput = ({ dispatch, language, instructions }) => (
  <div className="additional-pickup-instructions" style={{ marginTop: '1.5rem' }}>
    <strong>{language['returns.pickups_page.instructions.button']}</strong>
    {
      <TextAreaContainer>
        <TextArea
          id="pickupInstructions"
          name="pickupInstructions"
          label={language['returns.pickups_page.instructions.placeholder']}
          labelStyle={{ fontWeight: 300 }}
          value={instructions}
          onChange={({ target: { value } }) => dispatch(updatePickupInstructions(value))}
          maxLength={90}
          inputStyle={{
            resize: 'none',
            borderColor: '#cccccc',
          }}
        />
        <span
          style={{
            position: 'absolute',
            bottom: '0.7rem',
            right: '0.5rem',
            fontSize: '10px',
            fontWeight: 500,
            color: '#767676',
          }}
        >
          {`${instructions.length}/90`}
        </span>
      </TextAreaContainer>
    }
  </div>
);

InstructionsInput.defaultProps = {
  brandCtaColor: '#000000',
};

InstructionsInput.propTypes = {
  dispatch: PropTypes.func.isRequired,
  language: PropTypes.object.isRequired,
  showInstructions: PropTypes.bool.isRequired,
  instructions: PropTypes.string.isRequired,
  brandCtaColor: PropTypes.string,
};

export default connect(mapStateToProps)(InstructionsInput);
